// Ensure jQuery is loaded first
jQuery(document).ready(function($) {

    $('.carousal-container').slick({
    
        slidesToShow: 4,
        slidesToScroll: 2,
      
        prevArrow: '<button type="button" class="slick-prev prev"><img src="https://cdn.shopify.com/s/files/1/0623/6756/3820/files/spotlight-arrow.png?v=1718882187" /></button>',
        nextArrow: '<button type="button" class="slick-next next"><img src="https://cdn.shopify.com/s/files/1/0623/6756/3820/files/spotlight-arrow.png?v=1718882187" /></button>',
        responsive: [  
            {
                breakpoint: 1550,
                settings: {
                    slidesToShow: 3,
                     slidesToScroll: 1,
                    //  centerMode: true,
                    //  centerPadding: '150px',
                }
            },          
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                     slidesToScroll: 1,
                     centerMode: true,
                     centerPadding: '150px',
                }
            },
          {
                breakpoint: 768,
                settings: {
                    arrows:false,
                    // dots: true,
                    centerMode: true,
                    centerPadding: '30px',
                    slidesToShow: 1,
                     slidesToScroll: 1,
                }
            }
        ]
    });
});



jQuery(document).ready(function($) {
    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
    //$()add-cart-custom
    $(".add-cart-custom").click(function(){
        console.log("testingggg.......")
        $(".shopify-product-form").trigger('submit');    
    });

    $(".blog-card").click(function(){
        console.log($(this).attr('data-url'))
        window.location.href = $(this).attr('data-url')
      });
    
      $(".product-link").click(function(){
        console.log($(this).attr('data-url'))
        window.location.href = $(this).attr('data-url')
      });

  $(".quiz-button").click(function () {
    $(".overlay").show();
    $(".cs").html("Coming Soon");
    $('.cs').css({
        'overflow': '',
        'text-align': 'center',
        'display': 'flex',
        'height': '100%',
        'justify-content': 'center',
        'align-items': 'center'
    });
    $('.popup').css({
        'position': 'relative',
        'width': isMobile ? '100%' : '442px',
        'height': '211px',
    });
    if ($(this).hasClass("fowc")) {
        $(".cs").html(" ")
        $('.cs').css({
            'height': isMobile ? 'auto' : '80vh',
            'overflow': 'scroll',

        });
        $('.popup').css({
            'position': 'relative',
            'width': isMobile ? '100%' : '90%',
            'height': isMobile ? '211px' : '90%',
            'overflow': 'hidden'
        });
        $(".cs").html("<iframe src='https://cdn.shopify.com/s/files/1/0268/0848/4047/files/Flow_Chart.pdf?v=1727934102' frameborder='0' width='100%' height='100%'></iframe>")
    }
    
    $(".popup-card").show();
});

$(".close-popup").click(function () {
    $(".overlay").hide();
    $(".popup-card").hide();
});

$(document).on('keydown', function (event) {
    if (event.key == "Escape") {
        $(".close-popup").trigger('click');
    }
});


    
$('.slider1').slick({
    autoplay: false, // Enable autoplay
    arrows:false,
    autoplaySpeed: 2000, // Set autoplay speed to 3 seconds
    dots: true, // Enable dots navigation
    infinite: true, // Loop the slider  
    speed: 500, // Transition speed between slides in milliseconds
    slidesToShow: 3, // Number of slides to show at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    responsive: [
            
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                }
            },
          {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
});


$('.slider2').slick({
    autoplay: false, // Enable autoplay
    arrows:false,
    autoplaySpeed: 2000, // Set autoplay speed to 3 seconds
    dots: true, // Enable dots navigation
    infinite: true, // Loop the slider  
    speed: 500, // Transition speed between slides in milliseconds
    slidesToShow: 3, // Number of slides to show at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    responsive: [
            
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                }
            },
          {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
});



  });


